


















































































































import Vue from 'vue'
import Component from 'vue-class-component'
import LocaleDetailComponent from '@/modules/i18n/components/LocaleDetail.vue'
import {State, Mutation, Action} from 'vuex-class'
import Locale from '@/modules/i18n/model/Locale'

@Component({
    components: {
        'locale-detail': LocaleDetailComponent,
    },
})
export default class LocaleListComponent extends Vue {
    public localeDetailDialog = false
    public isLoading = true
    public isDeleting = false
    @State(state => state.i18n.locales)
    public locales: Locale[]

    @Mutation('showLoadingScreen')
    public showLoadingScreen: (payload: { message: string }) => void

    @Mutation('hideLoadingScreen')
    public hideLoadingScreen: () => void

    public localeSelectedToDelete = new Locale(0, '')
    public showLocaleDeletionDialog = false
    public headers = [
        {text: 'Identificador', value: 'identifier'},
        {text: 'Nombre', value: 'name'},
        {text: 'Fecha de creación', value: 'createdAt'},
        {text: 'Fecha última actualización', value: 'updatedAt'},
        {text: 'Acciones', value: 'id', sortable: false, align: 'center'},
    ]

    public mode = 0


    public selectLocaleToDelete (locale: Locale) {
        this.localeSelectedToDelete = locale
        this.showLocaleDeletionDialog = true
    }

    public async deleteLocale () {
        this.isDeleting = true
        await this.$store.dispatch('i18n/deleteLocale', {
            locale: this.localeSelectedToDelete.identifier,
        })

        this.isDeleting = false
        this.showLocaleDeletionDialog = false

        this.$store.commit('showNotification', {
            message: `Se ha elminado correctamente el idioma ${this.localeSelectedToDelete.identifier}`,
            color: 'success',
        })

        this.localeSelectedToDelete = new Locale(0, '')
    }

    public async created () {
        this.showLoadingScreen({
            message: 'Cargando lista de idiomas',
        })

        await this.$store.dispatch('i18n/loadLocales', {
            preserve: true,
        })

        this.isLoading = false

        this.hideLoadingScreen()
    }
}
